import { render, staticRenderFns } from "./PileMovements.vue?vue&type=template&id=bdf5e7a4"
import script from "./PileMovements.vue?vue&type=script&lang=js"
export * from "./PileMovements.vue?vue&type=script&lang=js"
import style0 from "./PileMovements.vue?vue&type=style&index=0&id=bdf5e7a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports